import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, Fragment as _Fragment, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = ["read-only", "disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_field_label = _resolveComponent("field-label")
  const _component_field_error = _resolveComponent("field-error")

  return (_openBlock(), _createElementBlock("div", _mergeProps({ ref: "field" }, _ctx.$attrs, {
    "read-only": _ctx.readOnly || null,
    disabled: _ctx.disabled || null,
    class: $options.fieldClass
  }), [
    ($props.layout === 'condensed')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          ($props.showLabel && $props.displayName)
            ? _renderSlot(_ctx.$slots, "label", { key: 0 }, () => [
                _createVNode(_component_field_label, {
                  class: _normalizeClass($props.labelClass),
                  text: $props.displayName,
                  "is-required": _ctx.isRequired,
                  description: $props.description,
                  "tooltip-text": $props.tooltipText
                }, _createSlots({ _: 2 /* DYNAMIC */ }, [
                  (_ctx.$slots['field-description'])
                    ? {
                        name: "description",
                        fn: _withCtx(() => [
                          _renderSlot(_ctx.$slots, "field-description")
                        ]),
                        key: "0"
                      }
                    : undefined,
                  (_ctx.$slots.tooltip)
                    ? {
                        name: "tooltip",
                        fn: _withCtx(() => [
                          _renderSlot(_ctx.$slots, "tooltip")
                        ]),
                        key: "1"
                      }
                    : undefined
                ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["class", "text", "is-required", "description", "tooltip-text"])
              ])
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", {
            class: _normalizeClass(["gfu-field__holder", $options.holderClass])
          }, [
            ($options.hasPrepend)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass($options.prependClass)
                }, _toDisplayString($props.prepend), 3 /* TEXT, CLASS */))
              : _createCommentVNode("v-if", true),
            _renderSlot(_ctx.$slots, "default", { fieldId: _ctx.fieldId }),
            ($options.hasAppend)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass($options.appendClass),
                  "data-qa": "field-append"
                }, _toDisplayString($props.append), 3 /* TEXT, CLASS */))
              : _createCommentVNode("v-if", true),
            (_ctx.hasError)
              ? (_openBlock(), _createBlock(_component_field_error, {
                  key: 2,
                  name: _ctx.name,
                  "validator-layout": $props.validatorLayout,
                  "data-qa": "field-error"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString($options.errorMessage), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["name", "validator-layout"]))
              : _createCommentVNode("v-if", true)
          ], 2 /* CLASS */)
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("v-if", true),
    ($props.layout === 'columns')
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass($options.gridClass)
        }, [
          _createElementVNode("div", {
            class: _normalizeClass($options.labelColumnClass)
          }, [
            ($props.showLabel)
              ? _renderSlot(_ctx.$slots, "label", { key: 0 }, () => [
                  _createVNode(_component_field_label, {
                    "is-required": _ctx.isRequired,
                    class: _normalizeClass($props.labelClass),
                    text: $props.displayName,
                    description: $props.description,
                    layout: $props.layout,
                    "tooltip-text": $props.tooltipText,
                    "read-only": _ctx.readOnly
                  }, _createSlots({ _: 2 /* DYNAMIC */ }, [
                    (_ctx.$slots['field-description'])
                      ? {
                          name: "description",
                          fn: _withCtx(() => [
                            _renderSlot(_ctx.$slots, "field-description")
                          ]),
                          key: "0"
                        }
                      : undefined,
                    (_ctx.$slots.tooltip)
                      ? {
                          name: "tooltip",
                          fn: _withCtx(() => [
                            _renderSlot(_ctx.$slots, "tooltip")
                          ]),
                          key: "1"
                        }
                      : undefined
                  ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["is-required", "class", "text", "description", "layout", "tooltip-text", "read-only"])
                ])
              : _createCommentVNode("v-if", true)
          ], 2 /* CLASS */),
          _createElementVNode("div", {
            class: _normalizeClass($options.inputColumnClass)
          }, [
            ($options.hasPrepend)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass($options.prependClass),
                  "data-qa": "unit"
                }, _toDisplayString($props.prepend), 3 /* TEXT, CLASS */))
              : _createCommentVNode("v-if", true),
            _renderSlot(_ctx.$slots, "default", { fieldId: _ctx.fieldId }),
            ($options.hasAppend)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass($options.appendColumnClass),
                  "data-qa": "unit"
                }, _toDisplayString($props.append), 3 /* TEXT, CLASS */))
              : _createCommentVNode("v-if", true),
            (_ctx.hasError)
              ? (_openBlock(), _createBlock(_component_field_error, {
                  key: 2,
                  name: _ctx.name,
                  "validator-layout": $props.validatorLayout,
                  "data-qa": "field-error"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString($options.errorMessage), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["name", "validator-layout"]))
              : _createCommentVNode("v-if", true)
          ], 2 /* CLASS */)
        ], 2 /* CLASS */))
      : _createCommentVNode("v-if", true)
  ], 16 /* FULL_PROPS */, _hoisted_1))
}